import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { FundDetails } from "../../types/invest";

export interface RecentlyViewedFund extends Partial<FundDetails> {
  scheme: string; // scheme code
  fund: string; // fund name
  plan: string;
  option: string;
  viewedAt: number; // timestamp when viewed
}

export interface RecentlyViewedState {
  funds: RecentlyViewedFund[];
}

const initialState: RecentlyViewedState = {
  funds: [],
};

const recentlyViewedSlice = createSlice({
  name: "recentlyViewed",
  initialState,
  reducers: {
    addRecentlyViewedFund: (state, action: PayloadAction<RecentlyViewedFund>) => {
      const newFund: RecentlyViewedFund = {
        ...action.payload,
        viewedAt: Date.now(),
      };

      // Remove if fund already exists
      state.funds = state.funds?.filter(
        (f) =>
          !(
            f.scheme === newFund.scheme &&
            f.plan === newFund.plan &&
            f.option === newFund.option
          ),
      );

      // Add to beginning (most recent first)
      state.funds?.unshift(newFund);

      // Keep only last 20 viewed funds
      state.funds = state.funds?.slice(0, 20);
    },

    clearRecentlyViewed: (state) => {
      state.funds = [];
    },
  },
});

export const { addRecentlyViewedFund, clearRecentlyViewed } = recentlyViewedSlice.actions;
export const recentlyViewedReducer = recentlyViewedSlice.reducer;
